import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';

const props = {
  headerDef: PropTypes.object,
  data: PropTypes.any,
  defaultCellStyle: PropTypes.object,
  colCellsStyle: PropTypes.object,
  filters: PropTypes.object,
  dataId: PropTypes.string,
  onClickCell: PropTypes.func,
  style: PropTypes.object,
  gridPosition: PropTypes.string
};

const escapeRegExp = text => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

const GridDataCell = (props) => {
  const {
    headerDef,
    filters,
    defaultCellStyle,
    colCellsStyle,
    style,
    theme,
    dataId,
    gridPosition
  } = props;
  const { colStyles, field, overrideDefaultCellStyles = {} } = headerDef;

  const {
    gridRowsTextColor,
    gridRowsRightBorderColor,
    gridRowsLinkTextColor,
    gridRowsBottomBorderColor,
    gridRowsFontSize,
    gridHighlightTextBackground,
    gridHighlightTextColor,
  } = theme;

  const { width, textAlign } = colStyles;

  // Highlight filter values
  // TODO: partial word highlight
  const getHighlightedText = (text, highlight) => {
    const hightlightParts = highlight.split(' ');
    let regexString = '';

    // Build regex for highlighted text
    for (let i = 0; i < hightlightParts.length; i++) {
      const tmpRegex = escapeRegExp(hightlightParts[i]); // Partial word search
      regexString = regexString + `(${tmpRegex})${i < hightlightParts.length - 1 ? '|' : ''}`;
    }

    const parts = text.split(new RegExp(regexString, 'gi'));
    return (
      <span>
        {parts.map((part, idx) => {
          if (!part) { return null; }
          if (hightlightParts.findIndex(item => part.toLowerCase() === item.toLowerCase()) > -1) {
            return (
              <b
                key={`${props.dataId}_${idx}`}
                style={{ color: gridHighlightTextColor, background: gridHighlightTextBackground }}
              >
                {part}
              </b>
            );
          }
          return part;
        }
        )}
      </span>
    );
  };

  const styles = StyleSheet.create({
    cells: {
      // borderBottom: `1px solid ${gridRowsBottomBorderColor}`,
      borderRight: `1px solid ${gridRowsRightBorderColor}`,
      color: gridRowsTextColor,
      whiteSpace: 'pre-line',
      ':last-child': {
        borderRight: 'none'
      }
    }
  });

  // Handle on cell click
  const handleClick = (e) => {
    if (props.headerDef.enableCellClick) {
      props.onClickCell(props.headerDef.field, props.data, props.recordId, e, props.rowIndex);
    }
  };

  const getText = (text) => {
    if (filters[field] && filters[field].value !== '') {
      return getHighlightedText(text, filters[field].value);
    }
    return text;
  };

  return (
    <div
      className={css(styles.cells)}
      onClick={handleClick}
      style={{
        ...style,
        ...defaultCellStyle,
        ...overrideDefaultCellStyles,
        width: `${width - 1}px`,
        textAlign,
        flexShrink: '0',
        flexGrow: '0'
      }}
    >
      <div
        className='line-clamp'
        style={{ width: '100%', ...colCellsStyle }}
      >
        {typeof headerDef.cellRenderer !== 'function'
          ? getText(props.data)
          : headerDef.cellRenderer(props.data, getText)
        }
      </div>
    </div>
  );
};

GridDataCell.propTypes = props;

export { GridDataCell };
